var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetinoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3438 24C14.3561 24 12.8101 22.3551 12.8101 20.4112C12.8101 18.4673 14.4297 16.8224 16.3438 16.8224C18.2579 16.8224 19.8775 18.4673 19.8775 20.4112C19.8775 22.3551 18.2579 24 16.3438 24ZM16.3438 18.9906C15.6076 18.9906 15.0186 19.5888 15.0186 20.3364C15.0186 21.0841 15.6076 21.6822 16.3438 21.6822C17.08 21.6822 17.669 21.0841 17.669 20.3364C17.669 19.5888 17.08 18.9906 16.3438 18.9906Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78528 18.7664C2.13497 18.7664 0 16.5982 0 13.9066C0 11.1402 2.13497 8.97198 4.78528 8.97198C7.43558 8.97198 9.57055 11.1402 9.57055 13.8318C9.64417 16.5982 7.5092 18.7664 4.78528 18.7664ZM4.78528 11.215C3.31288 11.215 2.20859 12.4112 2.20859 13.8318C2.20859 15.2524 3.3865 16.4486 4.78528 16.4486C6.18405 16.4486 7.36196 15.2524 7.36196 13.8318C7.36196 12.4112 6.25767 11.215 4.78528 11.215Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5215 13.1589C13.9141 13.1589 11.043 10.1682 11.043 6.57944C11.043 2.99065 13.9878 0 17.5215 0C21.0552 0 24 2.99065 24 6.57944C24 10.1682 21.1289 13.1589 17.5215 13.1589ZM17.5215 2.24299C15.1657 2.24299 13.2516 4.18692 13.2516 6.57944C13.2516 8.97196 15.1657 10.9159 17.5215 10.9159C19.8773 10.9159 21.7914 8.97196 21.7914 6.57944C21.7914 4.18692 19.8773 2.24299 17.5215 2.24299Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetinoid);
export default __webpack_public_path__ + "static/media/retinoid.bbd444a6b0d40ffc55ff4587f84055b5.svg";
export { ForwardRef as ReactComponent };